/* Polsk katalog for locale-closing-sales-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'route.arsavslutning-salg': 'Sprzedaż',
  'clo.sales.title': 'Sprzedaż',
  'clo.sales.openReview': 'Zobacz kontrolę sprzedaży',
  'clo.sales.year': 'Rok podatkowy {{year}}',
  'clo.sales.subtitle': 'Automatyczna kontrola szkiców i braków w dokumentach sprzedaży za {{year}}.',
  'clo.sales.pending': 'Dokumenty sprzedaży do obsłużenia, zanim krok sprzedaży za {{year}} będzie gotowy: {{count}}.',
  'clo.sales.ready': 'Kontrola dokumentów za {{year}} została zakończona automatycznie. Nie znaleziono szkiców ani braków.',
  'clo.sales.followUp': 'Dokumenty sprzedaży za {{year}} przeszły kontrolę księgową. Wysyłki wymagające działań: {{followUps}}.',
  'clo.sales.unsupported': 'Krok sprzedaży nie jest obsługiwany dla tego kraju, przepisów lub roku.',
  'clo.sales.issuesTitle': 'Szkice i braki',
  'clo.sales.noIssues': 'Brak szkiców lub niekompletnych dokumentów sprzedaży w tej kontroli.',
  'clo.sales.draft': 'Szkic należy dokończyć lub usunąć, jeśli sprzedaż nie ma dojść do skutku.',
  'clo.sales.undated': 'Brak prawidłowej daty dokumentu. Ustal, do którego roku należy sprzedaż.',
  'clo.sales.incomplete': 'Dokument jest niekompletny. Sprawdź numer, linie i opis.',
  'clo.sales.unknownDate': 'Rok wymaga wyjaśnienia',
  'clo.sales.followUpsTitle': 'Sprawdź wysyłkę',
  'clo.sales.unsent': 'Brak wysyłki zarejestrowanej w Plumme',
  'clo.sales.deliveryFailed': 'Ostatni e-mail nie dotarł lub został odrzucony',
  'clo.sales.sendingHelp': 'Sprawdź, czy klient otrzymał dokument. Wysyłka jest pokazywana oddzielnie od księgowania: dokumenty mogły zostać dostarczone poza Plumme, a status e-maila nie dokumentuje, kiedy przychód został osiągnięty.',
  'clo.sales.receivablesTitle': 'Otwarte pozycje klientów na 31.12.{{year}}',
  'clo.sales.receivablesHelp': 'Pokazuje faktury i faktury korygujące w Plumme, które były otwarte na przełomie roku, także z wcześniejszych lat. Późniejsze płatności nie zmieniają kwoty na 31.12. Nie jest to pełne uzgodnienie konta 1500 ani zaimportowanej historii.',
  'clo.sales.settledAfter': 'Rozliczono po przełomie roku: {{amount}}',
  'clo.sales.noReceivables': 'Nie znaleziono otwartych pozycji klientów w tej podstawie na przełomie roku.',
  'clo.sales.otherSalesTitle': 'Inna zaksięgowana sprzedaż',
  'clo.sales.invoiceListTitle': 'Lista faktur',
  'clo.sales.approveWithoutChanges': 'Zatwierdź bez zmian',
  'clo.sales.otherSale': 'Inna sprzedaż',
  'clo.sales.invoice': 'Faktura',
  'clo.sales.credit': 'Faktura korygująca',
  'clo.sales.openDocument': 'Otwórz dokument',
  'clo.sales.openList': 'Otwórz listę faktur',
  'clo.sales.scopeHelp': 'Data dokumentu decyduje, które sprzedaże są wyświetlane. Dokumenty bez daty wymagają wyjaśnienia; data utworzenia nie jest używana jako data sprzedaży. Oferty i potwierdzenia zamówienia nie są automatycznie osiągniętą sprzedażą. Rozgraniczenie okresów, brakujące fakturowanie, straty, waluty i pełne uzgodnienie są oceniane w osobnych kontrolach.',
  'clo.sales.back': 'Wróć do kontroli sprzedaży',
  'clo.sales.backToClosing': 'Wróć do zamknięcia roku',
  'clo.sales.loadError': 'Nie udało się otworzyć obszaru sprzedaży.',
  'clo.sales.documentGone': 'Dokumentu nie ma już na liście faktur. Wróć, aby odświeżyć kontrolę.',
});
